import { createAction, props } from '@ngrx/store';

export const loadSubscriptionPlans = createAction(
  '[Subscription Plans] Load Subscription Plans'
);
export const loadSubscriptionPlansSuccess = createAction(
  '[Subscription Plans] Load Subscription Plans Success',
  props<{ plans: any[] }>()
);
export const loadSubscriptionPlansFailure = createAction(
  '[Subscription Plans] Load Subscription Plans Failure',
  props<{ error: any }>()
);

export const userSubscribeToPlan = createAction(
  '[Subscription Plans] User Subscribe To Plan',
  props<{ planId: string; userId: string }>()
);
export const userSubscribeToPlanSuccess = createAction(
  '[Subscription Plans] User Subscribe To Plan Success',
  props<{ planId: string; userId: string }>()
);
export const userSubscribeToPlanFailure = createAction(
  '[Subscription Plans] User Subscribe To Plan Failure',
  props<{ error: any }>()
);

export const loadUserActiveSubscriptions = createAction(
  '[Subscription Plans] Load User Active Subscriptions',
  props<{ userId: string }>()
);
export const loadUserActiveSubscriptionsSuccess = createAction(
  '[Subscription Plans] Load User Active Subscriptions Success',
  props<{ subscriptions: any[] }>()
);
export const loadUserActiveSubscriptionsFailure = createAction(
  '[Subscription Plans] Load User Active Subscriptions Failure',
  props<{ error: any }>()
);
